// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ByteOrder } from "./byte-order";

/**
 * UDP event datagram decode.
 */
export class EventDecode implements flatbuffers.IUnpackableObject<EventDecodeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventDecode {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventDecode(bb: flatbuffers.ByteBuffer, obj?: EventDecode): EventDecode {
    return (obj || new EventDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEventDecode(
    bb: flatbuffers.ByteBuffer,
    obj?: EventDecode,
  ): EventDecode {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventDecode()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  byteOrder(): ByteOrder | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  minLen(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startEventDecode(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addByteOrder(builder: flatbuffers.Builder, byteOrder: ByteOrder) {
    builder.addFieldInt8(0, byteOrder, null);
  }

  static addMinLen(builder: flatbuffers.Builder, minLen: number) {
    builder.addFieldInt16(1, minLen, 0);
  }

  static endEventDecode(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createEventDecode(
    builder: flatbuffers.Builder,
    byteOrder: ByteOrder | null,
    minLen: number,
  ): flatbuffers.Offset {
    EventDecode.startEventDecode(builder);
    if (byteOrder !== null) EventDecode.addByteOrder(builder, byteOrder);
    EventDecode.addMinLen(builder, minLen);
    return EventDecode.endEventDecode(builder);
  }

  unpack(): EventDecodeT {
    return new EventDecodeT(this.byteOrder(), this.minLen());
  }

  unpackTo(_o: EventDecodeT): void {
    _o.byteOrder = this.byteOrder();
    _o.minLen = this.minLen();
  }

  unpackFields(...fields: string[]): EventDecodeT {
    const t = new EventDecodeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("byte_order")) {
      t.byteOrder = this.byteOrder();
    }
    if (fieldSet.has("min_len")) {
      t.minLen = this.minLen();
    }
    return t;
  }
}

export class EventDecodeT implements flatbuffers.IGeneratedObject {
  constructor(
    public byteOrder: ByteOrder | null = null,
    public minLen: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return EventDecode.createEventDecode(builder, this.byteOrder, this.minLen);
  }

  clone(): EventDecodeT {
    const obj = new EventDecodeT();
    obj.byteOrder = this.byteOrder;
    obj.minLen = this.minLen;
    return obj;
  }

  equals(other: EventDecodeT): boolean {
    if (this.byteOrder !== other.byteOrder) return false;
    if (this.minLen !== other.minLen) return false;
    return true;
  }
}

export function verifyEventDecode(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 2);
  } finally {
    verifier.popDepth();
  }
}
